<template>




    <div style="background-color: #FCA94C; height: 20vh; width: 100vw" >

        <img src="../../../assets/images/sushiHub/homeBannerMobile.svg"  class="sushi-header-mobile"  alt="image">

    </div>

</template>

<script>
import {getCurrentDate, operatingHours} from "@/api/helpers/datetimeHelper";

export default {
  name: "sushiStoreBannerMobile",
  props :  ['store'],
  methods: {

    getOperatingHours(storedoc) {
      var now = getCurrentDate(storedoc.TimezoneCity);
      return operatingHours(storedoc.BlackoutDates, now, storedoc.OperatingHours);
    },
  }
}
</script>

<style scoped>

</style>
